<!-- <section class="bg-light-red page-title-section top-position1 bg-img cover-background left-overlay-secondary">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <article class="card-style-10 rounded h-100 border-0">
                    <div class="card-body rounded">
                        <div>
                            <h3 class="mb-3">Privacy Policy</h3>
                            <p>
                                Redmonk is committed to protecting the privacy of our customers and website visitors.
                                This Privacy Policy outlines the type of information we collect, how we use it,
                                and the choices you have regarding your personal data.
                            </p>
                            <h5 class="mt-4 mb-1">Information We Collect</h5>
                            <p>
                                When you visit our website or interact with our services, we may collect personal
                                information such as your name, email address, phone number, and any other details
                                you provide through forms or enquiries.
                            </p>
                            <p>
                                We may also collect certain technical information automatically, including your IP
                                address,
                                browser type, device details, and browsing behavior on our website.
                            </p>
                            <p>
                                If you book a service or consultation with us, we may collect additional details
                                relevant
                                to the service, such as your preferences or any information necessary to deliver a
                                better
                                experience.
                            </p>
                            <h5 class="mt-4 mb-1">How We Use Your Information</h5>
                            <p>
                                We use the information we collect to provide you with a smooth and personalized
                                experience.
                                This includes:
                            </p>
                            <ul class="mb-3">
                                <li>Responding to your enquiries</li>
                                <br>
                                <li>Scheduling and managing appointments or services</li>
                                <br>
                                <li>Providing updates related to your request</li>
                                <br>
                                <li>Improving our services and customer experience</li>
                                <br>
                                <li>Analyzing trends and user behavior for better service
                                    delivery
                                </li>
                                <li></li>
                            </ul>
                            <p>
                                If you share your contact details with us, we may occasionally send you updates or
                                relevant
                                offers.
                                You can opt out of these communications at any time.
                            </p>
                            <h5 class="mt-4 mb-1">Your Choices</h5>
                            <p>
                                You have the option to share as much or as little information as you prefer.
                                However, some information is necessary for us to deliver our services effectively.
                            </p>
                            <p>
                                We do not sell or rent your personal information to third parties. We may share your
                                data only
                                with trusted service providers (such as payment processors or communication tools)
                                strictly
                                to help us deliver our services.
                            </p>
                            <h5 class="mt-4 mb-1">Data Security</h5>
                            <p>
                                We take appropriate security measures to protect your personal information from
                                unauthorized
                                access,
                                misuse, or disclosure. Sensitive information, if collected, is handled securely using
                                standard
                                encryption and protection practices.
                            </p>
                            <h5 class="mt-4 mb-1">Updates to This Policy</h5>
                            <p>
                                Redmonk may update this Privacy Policy from time to time. Any changes will be reflected
                                on this
                                page,
                                and where necessary, we may notify you through appropriate channels.
                            </p>
                            <h5 class="mt-4 mb-1">Contact Us</h5>
                            <p>
                                If you have any questions about this Privacy Policy or how your data is handled, please
                                contact
                                us:
                            </p>
                            <ul>
                                <li><strong>Email:</strong> info@redmonkwellness.com</li>
                                <li><strong>Phone:</strong> +91 6209-26-26-26</li>
                                <li><strong>Phone:</strong> +91 62-62-662-662</li>
                                <li></li>
                            </ul>
                        </div>
                    </div>
                </article>
            </div>
        </div>
    </div>
</section> -->

<section class="bg-light-red page-title-section top-position1 bg-img cover-background left-overlay-secondary">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <article class="card-style-10 rounded h-100 border-0">
                    <div class="card-body rounded">

                        <div>
                            <h3 class="mb-3">Privacy Policy</h3>

                            @for (s of sections(); track s.ID) {
                              @if (s.Title) {
                                <h5 class="mt-4 mb-1">{{ s.Title }}</h5>
                              }
                              <div class="policy-content" [innerHTML]="s.Content"></div>
                            }

                            @if (!loading() && !error() && !sections().length) {
                              <p class="text-center my-5">No content available.</p>
                            }
                            @if (error() && !sections().length) {
                              <p class="text-center my-5">Unable to load content right now.</p>
                            }
                        </div>

                    </div>
                </article>
            </div>
        </div>
    </div>
</section>